import React from 'react';
import './CommunityProfileHeader.css';
import {connect} from 'react-redux';
import Dropzone from 'react-dropzone';
import {canAdmin} from './community.selectors';
import {FancyButton, FancyPill, Spinner, ScrolledHeader} from '../widgets';
import FancyCheckbox from '../widgets/FancyCheckbox';
import actions from './community.actions';
import {uiActions} from '../chrome';
import {editingProfileActions} from '../profile/';
import {isSessionUserSystemAdmin} from '../user/session.selectors';

const BG_PREFIX = 'linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),';

export const CommunityProfileHeader = props => {
	if (!props.community || !props.community.profile) {
		return null;
	}

	const {
		community: {
			location,
			name,
			profile: {backgroundPosition = 33, backgroundImage, uniqueName, state},
			category,
			subscription
		},
		dropBackgroundFile,
		dragOverBackground,
		dragOutBackground,
		draggingOverBackgroundImage,
		updatingBackgroundImage,
		editDetails,
		isSystemAdmin,
		approveProfile,
		unapproveProfile,
		screenSize,
		setPaidCommunity,
		unsetPaidCommunity
	} = props;

	const editable = canAdmin(props); // OR global admin

	return (
		<div className="CommunityProfileHeader">
			<Dropzone
				className="CommunityProfileHeader-backdrop"
				style={{
					backgroundImage: updatingBackgroundImage
						? `${BG_PREFIX}url(${updatingBackgroundImage.preview})`
						: `${BG_PREFIX}url("/api/image/${backgroundImage}")`,
					backgroundPosition: `center ${backgroundPosition}%`
				}}
				onDrop={dropBackgroundFile}
				accept="image/jpeg, image/png"
				onDragEnter={dragOverBackground}
				onDragLeave={dragOutBackground}
				disabled={!editable}
				disableClick={true}>
				{updatingBackgroundImage && (
					<span
						style={{
							position: 'absolute',
							zIndex: 10,
							fontSize: '200%',
							right: 64,
							bottom: 16,
							overflow: 'hidden'
						}}>
						{Math.round(updatingBackgroundImage.progress * 100)}%
					</span>
				)}
				{updatingBackgroundImage && (
					<div
						style={{
							position: 'absolute',
							opacity: 0.5,
							background: 'white',
							bottom: 0,
							left: 0,
							right: 0,
							top: `${Math.round(updatingBackgroundImage.progress * 100)}%`
						}}
					/>
				)}
			</Dropzone>
			<div className="CommunityProfileHeader-details">
				<h1>{name}</h1>
				{screenSize !== 'mobile' && <ScrolledHeader>{name}</ScrolledHeader>}
				<div className="CommunityProfileHeader-category">
					<span className="CommunityProfileHeader-group">{category}</span>
				</div>
				<div className="CommunityProfileHeader-geo">
					<span className="icon-room" />
					<span className="CommunityProfileHeader-name">{location && location.suburb}</span>
				</div>
				{editable && (
					<div className="CommunityProfileHeader-editable">
						<span>You are administering {name}'s profile</span>
						<FancyButton onClick={editDetails}>
							<span className="icon icon-mode_edit" />
							<span>Edit {name}'s details</span>
						</FancyButton>
						<br />
						{state === 'unapproved' && (
							<span className="unapprovedText">This community is unapproved</span>
						)}
						{isSystemAdmin ? (
							<React.Fragment>
								<p>
									<FancyCheckbox
										checked={state === 'approved'}
										onChange={state === 'approved' ? unapproveProfile : approveProfile}
									/>
									<span>Approve community's profile</span>
								</p>
								<p>
									<FancyCheckbox
										checked={subscription}
										onChange={subscription ? unsetPaidCommunity : setPaidCommunity}
									/>
									<span>Enable paid community features</span>
								</p>
							</React.Fragment>
						) : (
							undefined
						)}
					</div>
				)}
			</div>
			{editable && (
				<Dropzone
					className={`CommunityProfileHeader-photoedit ${
						draggingOverBackgroundImage ? 'over' : ''
					} ${updatingBackgroundImage ? 'updating' : ''}`}
					onDrop={dropBackgroundFile}
					accept="image/jpeg, image/png"
					onDragEnter={dragOverBackground}
					onDragLeave={dragOutBackground}
					disabled={!editable}>
					{!updatingBackgroundImage && <span className="icon icon-photo_camera" />}
					{updatingBackgroundImage && <Spinner />}
				</Dropzone>
			)}
		</div>
	);
};

const ConnectedCommunityProfileHeader = connect(
	state => {
		const {community, session, location, categories, ui} = state || {};
		return {
			community,
			sessionProvider: session && session.current,
			isSystemAdmin: isSessionUserSystemAdmin(state),
			suburbs: location && location.suburbs,
			categories: categories && categories.community,
			screenSize: ui.screenSize
		};
	},
	dispatch => ({
		approveProfile: () =>
			dispatch(
				actions.persistCommunityField({
					profile: {
						state: 'approved'
					}
				})
			),
		unapproveProfile: () =>
			dispatch(
				actions.persistCommunityField({
					profile: {
						state: 'unapproved'
					}
				})
			),
		setPaidCommunity: () => dispatch(actions.persistCommunityField({subscription: true})),
		unsetPaidCommunity: () =>
			dispatch(
				actions.persistCommunityField({subscription: false, profile: {customColour: undefined}})
			),
		editDetails: () => {
			dispatch(editingProfileActions.initCommunity());
			dispatch(uiActions.uiModal('profile-edit-details'));
		},
		dragOverBackground: () => dispatch(actions.communityDragOverBackgroundImage()),
		dragOutBackground: () => dispatch(actions.communityDragOutBackgroundImage()),
		dropBackgroundFile: acceptedFiles =>
			acceptedFiles[0] && dispatch(actions.uploadBackgroundImage(acceptedFiles[0]))
	})
)(CommunityProfileHeader);

export default ConnectedCommunityProfileHeader;



// WEBPACK FOOTER //
// ./src/community/CommunityProfileHeader.js